import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import { Modal } from 'react-bootstrap';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { api as axiosApi } from '../../../../api';
import CustomInput from '../../../../components/common/Input/input';
import SettingsBreadcrumb from '../../../../components/SettingsBreadcrumb';
import './inserir-noticia.scss'
import 'bootstrap/dist/css/bootstrap.min.css';
import {
  Flex,
  Heading,
  Box,
  Button,
  FormLabel,
  FormControl,
  Select,
  Tooltip,
  Stack,
  Checkbox,
  IconButton,
  RadioGroup,
  Radio,
  TagLabel,
  Tag,
  Wrap,
  TagCloseButton,
  WrapItem,
  Image,
  Text,
} from '@chakra-ui/react';
import { ImageDropzone } from '../../../PublishContent/components/Banner/imageDropzone';
import { FileWithPath } from 'react-dropzone';
import * as api from '../../../../api/noticia';
import CustomTextArea from '../../../../components/common/Textarea/textArea';
import Swal from 'sweetalert2';
import { listarCategoriasAtivas } from '../../../../api/categoria';
import { PublicacaoParams } from '../../../../interfaces/publicacao.interface';
import { obterUsuario } from '../../../../api/usuario';
import { FaPlus, FaMinus, FaTimes, FaImage } from 'react-icons/fa';
import { listarSecretariasAtivas } from '../../../../api/secretarias';
import * as apiOutrasPaginas from '../../../../api/outrasPaginas';
import QuillEditor from '../../../../components/common/QuillEditor';
import BibliotecaModal from '../../../../pages/EdicaoCidadeInteligente/OutrasPaginas/modeloOutrasPaginas/BibliotecaModal/BibliotecaModal';

interface Imagem {
  id: number;
  imagem: string;
  imagemPreview: string;
  posicaoImagem: string;
  tipo?: 'image' | 'video';
}

interface Secao {
  id: number;
  titulo: string;
  descricao: string;
  aberto: boolean;
  imagem: Imagem[];
}

type ValuePiece = Date | null;
type Value = ValuePiece | [ValuePiece, ValuePiece];

const InserirNoticia: React.FC = () => {
  const navigate = useNavigate();
  const today = new Date().toISOString().split('T')[0];

  const [formValues, setFormValues] = useState<{
    titulo: { value: string; error: boolean };
    data: { value: typeof today; error: boolean };
    dataFim: { value: ''; error: boolean };
    imagem: { value: string; error: boolean };
    dscResumo: { value: string; error: boolean };
    endereco: { value: string; error: boolean };
    creditoAutorNoticia: { value: string; error: boolean };
    creditoAutorImagem: { value: string; error: boolean };
    descricaoImagem: { value: string; error: boolean };
    altImagem: { value: string; error: boolean };
    texto: { value: string; error: boolean };
    categoriaId: { value: string; error: boolean };
    secretariaId: { value: any[]; error: boolean };
    paginaId: { value: any[]; error: boolean };
    usuarioId: { value: any; error: boolean };
    exigeAprovacao: { value: number; error: boolean };
    usarModelo1: { value: number; error: boolean };

  }>({
    titulo: { value: '', error: false },
    data: { value: today, error: false },
    dataFim: { value: '', error: false },
    imagem: { value: '', error: false },
    dscResumo: { value: '', error: false },
    endereco: { value: '', error: false },
    creditoAutorNoticia: { value: '', error: false },
    creditoAutorImagem: { value: '', error: false },
    descricaoImagem: { value: '', error: false },
    altImagem: { value: '', error: false },
    texto: { value: '', error: false },
    categoriaId: { value: '', error: false },
    secretariaId: { value: [], error: false },
    paginaId: { value: [], error: false },
    usuarioId: { value: null, error: false },
    exigeAprovacao: { value: 0, error: false },
    usarModelo1: { value: 0, error: false },

  });

  const [imageBase64, setImageBase64] = useState<string>('');
  const [isErrorModalOpen, setIsErrorModalOpen] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>('');
  const [isLoadingButton, setLoadingButton] = useState<boolean>(false);
  const [paginas, setPaginas] = useState<any[]>([]);
  const [aprovadores, setAprovadores] = useState<any[]>([]);
  const [seqUsuario, setSeqUsuario] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [temporaryTexto, setTemporaryTexto] = useState<string>('');
  const [isModalTextOpen, setIsModalTextOpen] = useState<boolean>(false);
  const [isSaveButtonDisabled, setIsSaveButtonDisabled] = useState(true);
  const [selectedPages, setSelectedPages] = useState<number[]>([]);
  const [selectedUser, setSelectedUser] = useState<number | null>(null);
  const [secretariasAtivas, setSecretariasAtivas] = useState<any[]>([]);
  const [categorias, setCategorias] = useState<any[]>([]);
  const [secretarias, setSecretarias] = useState<any[]>([]);
  const [secretariaSelecionada, setSecretariaSelecionada] = useState<number[]>([]);
  const [arquivo, setArquivo] = useState<any>();
  const [nomeArquivo, setNomeArquivo] = useState<any>();
  const [typeMidia, setTypeMidia] = useState<any>();
  const [arquivoSelecionado, setArquivoSelecionado] = useState<File | null>(null);
  const [inputValueTagUsuario, setInputValueTagUsuario] = useState('');
  const [tagUsuario, setTagUsuario] = useState<string>('');
  const [filtroNomPagina, setFiltroNomPagina] = useState<string>('');
  const [filtroNomSecretaria, setFiltroNomSecretaria] = useState<string>('');
  
  // Estados para Modelo 1
  const [selecao, setSelecao] = useState<Secao[]>([
    {
      id: 1,
      titulo: '',
      descricao: '',
      aberto: true,
      imagem: []
    },
  ]);
  const [bibliotecaOpen, setBibliotecaOpen] = useState<boolean>(false);
  const [secaoAtualId, setSecaoAtualId] = useState<number | null>(null);
  const [listaPosicaoImagem, setListaPosicaoImagem] = useState<
    { codPropriedade: number; dscPropriedade: string }[]
  >([]);
  
  const videoExts = ['.mp4', '.webm', '.ogg'];
  
  useEffect(() => {
    const storedUsuario = localStorage.getItem('dadosUsuario');
    
    if (storedUsuario) {
      try {
        const usuario = JSON.parse(storedUsuario);
        setSeqUsuario(usuario.seqUsuario);
        
        const fetchObterUsuario = async () => {
          try {
           const [data, ativas] = await Promise.all([
             obterUsuario(Number(usuario.seqUsuario)),
             listarSecretariasAtivas()
           ]);
           setSecretarias(
            data.usuarioSecretariaDTO?.length ? data.usuarioSecretariaDTO : ativas
          );
          } catch (error) {
            console.error("Erro ao obter usuario:", error);
          }
        };
  
        fetchObterUsuario();
  
      } catch (error) {
        console.error("Erro ao recuperar os dados do usuário:", error);
      }
    }
  
    const fetchCategorias = async () => {
      try {
        const data = await listarCategoriasAtivas();
        setCategorias(data);
      } catch (error) {
        console.error('Erro ao buscar categorias ativas:', error);
      }
    };
    
    const listarSecretarias = async () => {
      try {
        const data = await listarSecretariasAtivas();
        setSecretariasAtivas(data);
      } catch (error) {
        console.error('Erro ao buscar categorias ativas:', error);
      }
    };

    const listarPosicoes = async () => {
      try {
        const data = await apiOutrasPaginas.listarPosicaoImagem();
        setListaPosicaoImagem(data);
      } catch (error) {
        console.error('Erro ao listar posições de imagem:', error);
      }
    };
  
    listarSecretarias();
    fetchCategorias();
    listarPosicoes();
    fetchPaginas();
    fetchAprovadoresAtivos();
  }, []);  

  const fetchPaginas = async (nomPagina?: string) => {
    try {
      if (nomPagina && nomPagina.trim()) {
        // Chamada com filtro para o endpoint da API
        const url = `/paginas/ativas?nomPagina=${encodeURIComponent(nomPagina)}`;
        const response = await axiosApi.get(url);
        setPaginas(response.data);
      } else {
        // Chamada sem filtro usando a função padrão
        const data = await api.paginasAtivas();
        setPaginas(data);
      }
    } catch (error) {
      console.error('Erro ao buscar páginas ativas:', error);
    }
  };

  const fetchSecretarias = async (dscSecretaria?: string) => {
    try {
      if (dscSecretaria && dscSecretaria.trim()) {
        // Chamada com filtro para o endpoint da API
        const url = `/secretarias/ativas?dscSecretaria=${encodeURIComponent(dscSecretaria)}`;
        const response = await axiosApi.get(url);
        setSecretarias(response.data);
      } else {
        // Chamada sem filtro usando a função padrão
        const data = await listarSecretariasAtivas();
        setSecretarias(data);
      }
    } catch (error) {
      console.error('Erro ao buscar secretárias ativas:', error);
    }
  };

  const fetchAprovadoresAtivos = async () => {
    try {
      const data = await api.listarExecutores();
      setAprovadores(data);
    } catch (error) {
      console.error('Erro ao buscar lista de executores para aprovação:', error);
    }
  };

  const handleFieldChange = (field: keyof typeof formValues, value: any) => {
    setFormValues({ ...formValues, [field]: { value, error: false } });
  };

  const handleAddTagUsuario = () => {
    if (inputValueTagUsuario.trim()) {
      setTagUsuario(prevTagUsuario => {
        const newTag = inputValueTagUsuario.trim();
        return prevTagUsuario ? `${prevTagUsuario} ${newTag}` : newTag;
      });
      setInputValueTagUsuario('');
    }
  };

  const handleInputChangeTagUsuario = (e: any) => {
    const value = e.target.value;

    const valueWithoutSpaces = value.replace(/\s/g, '');
    if (valueWithoutSpaces && !valueWithoutSpaces.startsWith('@')) {
      setInputValueTagUsuario(`@${valueWithoutSpaces}`);
    } else {
      setInputValueTagUsuario(valueWithoutSpaces);
    }
  };

  const handleRemoveTagUsuario = (tagToRemove: string) => {
    setTagUsuario(prevTagUsuario => {
      const updatedTags = prevTagUsuario
        .split(' ')
        .filter(tag => tag !== tagToRemove)
        .join(' ');
      return updatedTags.trim();
    });
  };

  const handleCheckboxChange = (seqPagina: number, e: React.ChangeEvent<HTMLInputElement>) => {
    const isChecked = e.target.checked;

    setSelectedPages((prev) => {
      const updatedPages = isChecked ? [...prev, seqPagina] : prev.filter((id) => id !== seqPagina);
      return updatedPages;
    });

    setFormValues((prevValues: any) => {
      const updatedPaginaIdValue = isChecked
        ? [...prevValues.paginaId.value, seqPagina]
        : prevValues.paginaId.value.filter((id: number) => id !== seqPagina);

      return {
        ...prevValues,
        paginaId: { value: updatedPaginaIdValue },
        ordemBanner: { value: 0 },
      };
    });
  };

  const handleRadioChange = (seqUsuario: number, e: React.ChangeEvent<HTMLInputElement>) => {
    const isChecked = e.target.checked;

    setSelectedUser(isChecked ? seqUsuario : null);

    setFormValues((prevValues: any) => {
      const updatedUsuarioIdValue = isChecked ? seqUsuario : null;

      return {
        ...prevValues,
        usuarioId: { value: updatedUsuarioIdValue },
      };
    });
  };

  const handleCheckboxSecretaria = (codSecretaria: number, checked: boolean) => {
    setSecretariaSelecionada(prev =>
      checked ? Array.from(new Set([...prev, codSecretaria])) : prev.filter(id => id !== codSecretaria)
    );
  
    setFormValues(prev => {
      const current: number[] = Array.isArray(prev?.secretariaId?.value) ? prev.secretariaId.value : [];
      const next = checked
        ? Array.from(new Set([...current, codSecretaria]))
        : current.filter(id => id !== codSecretaria);
  
      return {
        ...prev,
        secretariaId: { ...prev.secretariaId, value: next, error: prev?.secretariaId?.error ?? false },
      };
    });
  };

  // Funções para Modelo 1
  const abrirBibliotecaDeFotos = (secaoId: number) => {
    setSecaoAtualId(secaoId);
    setBibliotecaOpen(true);
  };

  const handleSelectImageFromBiblioteca = (media: any) => {
    if (secaoAtualId === null) return;

    const url = decodeURIComponent(media.dscUriCdn || media.dscMidia);
    const limpar = url.split('?')[0].toLowerCase();

    const isVideo = videoExts.some(ext => limpar.endsWith(ext));

    const novaImagem: Imagem = {
      id: Date.now(),
      imagem: url,
      imagemPreview: url,
      posicaoImagem: '',
      tipo: isVideo ? 'video' : 'image'
    };

    setSelecao(prev =>
      prev.map(secao =>
        secao.id === secaoAtualId
          ? { ...secao, imagem: [...secao.imagem, novaImagem] }
          : secao
      )
    );

    setBibliotecaOpen(false);
  };

  const handleRemoveImagem = (secaoId: number, imgId: number) => {
    setSelecao(prevSelecao =>
      prevSelecao.map(secao =>
        secao.id === secaoId
          ? { ...secao, imagem: secao.imagem.filter(img => img.id !== imgId) }
          : secao
      )
    );
  };

  const handleSelecaoChange = (id: number, field: string, value: string) => {
    setSelecao(prevSelecao =>
      prevSelecao.map(secao =>
        secao.id === id ? { ...secao, [field]: value } : secao
      )
    );
  };

  const handleAtualizarPosicaoImagem = (secaoId: number, imgId: number, posicaoImagem: string) => {
    setSelecao(prevSelecao =>
      prevSelecao.map(secao =>
        secao.id === secaoId
          ? { ...secao, imagem: secao.imagem.map(img => img.id === imgId ? { ...img, posicaoImagem } : img) }
          : secao
      )
    );
  };

  const handleAddSelecao = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    const novaSelecao: Secao = {
      id: Date.now(),
      titulo: '',
      descricao: '',
      aberto: true,
      imagem: []
    };
    setSelecao(prevSelecao => [...prevSelecao, novaSelecao]);
  };

  const handleRemoverSelecao = (id: number) => {
    setSelecao(prevSelecao => prevSelecao.filter(secao => secao.id !== id));
  };

  const toggleSelecao = (id: number) => {
    setSelecao(prevSelecao =>
      prevSelecao.map(secao =>
        secao.id === id ? { ...secao, aberto: !secao.aberto } : secao
      )
    );
  };

  const getLabel = (codPropriedade: string) => {
    return listaPosicaoImagem.find(opt => opt.codPropriedade.toString() === codPropriedade)?.dscPropriedade || '';
  };  

  const handleSaveText = () => {
    handleFieldChange('texto', temporaryTexto);
    setIsModalTextOpen(false);
  };

  const handleOpenModal = () => {
    setTemporaryTexto(formValues.texto.value);
    setIsModalTextOpen(true);
  };

  useEffect(() => {
    const isAutorValid = formValues.creditoAutorNoticia.value.trim() !== '';
    setIsSaveButtonDisabled(!isAutorValid || !temporaryTexto);
  }, [formValues.creditoAutorNoticia.value, temporaryTexto]);

  const handleImageSelected = async (selected: FileWithPath | null) => {
    if (selected) {
      const isImage = selected.type.startsWith("image/");
      const isVideo = selected.type.startsWith("video/");
      const isAudio = selected.type.startsWith("audio/");

      setNomeArquivo(selected.name);
      setTypeMidia(selected.type);
      setArquivo(selected);

      if (isImage || isVideo || isAudio) {
        setArquivoSelecionado(selected);
        setArquivo(selected);

      } else {
        console.error("Tipo de arquivo não suportado.");
      }
    } else {
      setArquivo(null);
      setArquivoSelecionado(null);
      console.warn("Nenhum arquivo selecionado.");
    }
  };

  const handleInputRadioChange = (field: string, value: any) => {
    if (field === 'exigeAprovacao' && value === 0) {
      setFormValues({
        ...formValues,
        [field]: { error: false, value },
        usuarioId: { value: null, error: false }
      });
    } else {
      setFormValues({
        ...formValues,
        [field]: { error: false, value }
      });
    }
  };

  const isFormValid = () => {
    const { titulo, data, categoriaId, paginaId, usuarioId, exigeAprovacao } = formValues;

    if (exigeAprovacao.value == 1) {
      if (!usuarioId.value || usuarioId.value == null) {
        return false;
      }
    }

    const isValid = (
      titulo.value &&
      data.value &&
      categoriaId.value &&
      paginaId.value.length > 0 &&
      (exigeAprovacao.value == 0 || (exigeAprovacao.value == 1 && usuarioId.value != null))
    );
    return isValid;
  };

  const handleFormSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoadingButton(true);
  
    const {
      endereco,
      texto,
      creditoAutorImagem,
      creditoAutorNoticia,
      descricaoImagem,
      altImagem,
      dataFim,
      categoriaId,
      secretariaId,
      paginaId,
      usuarioId,
      titulo,
      data,
      usarModelo1
    } = formValues;

    // Validação para Modelo 1
    if (usarModelo1.value === 1) {
      let secoesValidas = true;
      for (const secao of selecao) {
        if (!secao.titulo.trim() || !secao.descricao.trim()) {
          secoesValidas = false;
          break;
        }
      }
      if (!secoesValidas) {
        setErrorMessage('Todas as seções devem ter título e descrição preenchidos.');
        setLoadingButton(false);
        setIsErrorModalOpen(true);
        return;
      }
    }

    if (usarModelo1.value === 0 && !endereco.value && !texto.value) {
      setErrorMessage(
        'É necessário informar o "Endereço de internet para a notícia" ou "Texto da notícia" para criar a notícia.'
      );
      setLoadingButton(false);
      setIsErrorModalOpen(true);
      return;
    }

    const pendencia = usuarioId.value
      ? {
          codPendencia: 1,
          seqSolicitante: seqUsuario,
          seqExecutor: usuarioId.value,
        }
      : null;
  
           let codSituacao = 1;
;
  
    if (data.value) {
      const dataDaPublicacao = data.value;
      const diaDeHoje = new Date().toISOString().split("T")[0];

      if (pendencia) {
        codSituacao = 5;
      } else if (dataDaPublicacao > diaDeHoje) {
        codSituacao = 1;
      } else if (dataDaPublicacao === diaDeHoje) {
        codSituacao = 2;
      }  
    } else {
      codSituacao = 2;
    }

    // Quando usando Modelo 1, extrair dados da primeira seção
    let textoFinal = texto.value || null;
    const creditoAutorImagemFinal = creditoAutorImagem.value || null;
    const descricaoImagemFinal = descricaoImagem.value || null;
    const altImagemFinal = altImagem.value || null;
    let binPublicacaoFinal = '';
    const arquivoSelecionadoFinal: File | null = arquivoSelecionado;

    let jsonModelo: string | null = null;

    if (usarModelo1.value === 1 && selecao.length > 0) {
      const primeiraSecao = selecao[0];
      textoFinal = primeiraSecao.descricao || null;
      
      // Se houver imagem na primeira seção, usar a primeira imagem
      if (primeiraSecao.imagem.length > 0) {
        const primeiraImagem = primeiraSecao.imagem[0];
        // Para mídias já no CDN, não fazer upload
        if (primeiraImagem.imagem.startsWith('http')) {
          binPublicacaoFinal = primeiraImagem.imagem;
        }
      }

      // Criar jsonModelo com as seções
      const jsonModeloData = {
        codModeloPagina: 1,
        tituloGeral: formValues.titulo.value,
        secoes: selecao.map(secao => ({
          id: secao.id,
          titulo: secao.titulo,
          descricao: secao.descricao,
          aberto: secao.aberto,
          imagem: secao.imagem.map(img => ({
            id: img.id,
            url: img.imagem,
            posicaoImagem: img.posicaoImagem,
            tipo: img.tipo,
          }))
        }))
      };

      jsonModelo = JSON.stringify(jsonModeloData);
    }

    const params: PublicacaoParams = {
      codTipoPublicacao: 1,
      nomePublicacao: formValues.titulo.value || null,
      datPublicacao: formValues.data.value ? formValues.data.value : null,
      datDespublicar: dataFim.value ? formValues.dataFim.value : null,
      seqUsuario: seqUsuario,
      binPublicacao: binPublicacaoFinal,
      dscResumo: formValues.dscResumo.value || null,
      urlBin: endereco.value || null,
      dscPublicacao: textoFinal,
      dscCreditoImagem: creditoAutorImagemFinal,
      dscCreditoNoticia: creditoAutorNoticia.value || null,
      dscDescricaoImagem: descricaoImagemFinal,
      dscAltImagem: altImagemFinal,
      seqCategoria: Number(categoriaId.value) || null,
      conteudoPaginaDTO: paginaId.value.map((id: any) => ({
        seqPagina: Number(id),
        numOrdem: 0,
      })),
      pendencia: pendencia,
      numAprovacao: pendencia ? 1 : 0,
      dscCitacaoUsuario: tagUsuario,
      numAprovado: 0,
      codSituacaoPubli: codSituacao,
      datInicioEvento: null,
      datFimEvento: null,
      dscHoraInicioEvento: null,
      dscHoraFimEvento: null,
      dscTags: null,
      numRegistro: 1,
      contasRedeSocial: null,
      dscEnderecoEvento: null,
      conteudoSecretariaDTO: secretariaId.value.map((id: number) => ({
        codSecretaria: id,
      })),
      ...(usarModelo1.value === 1 && { codModeloPagina: 1, jsonModelo: jsonModelo }),
    };

    try {
      if (arquivoSelecionado) {
        const formData = new FormData();
        formData.append("file", arquivoSelecionado);

        const fileExtension = arquivoSelecionado.name.split('.').pop();
        let fileNameToSend = 'noticia';

        if (
          fileExtension &&
          !fileNameToSend.toLowerCase().endsWith(`.${fileExtension.toLowerCase()}`)
        ) {
          fileNameToSend = `${fileNameToSend}.${fileExtension}`;
        }

        const nomePasta = 'publicacoes';

        formData.append("fileName", fileNameToSend);
        formData.append("folderName", nomePasta);

        const cdnData = await api.inserirNoticiaNoCdn(formData);

        let cdnUrl = "";
        if (typeof cdnData === "string") {
          const regex = /(https?:\/\/[^\s]+)/g;
          const match = cdnData.match(regex);
          if (match && match[0]) {
            cdnUrl = match[0];
          } else {
            throw new Error("URL não encontrada na resposta do CDN.");
          }
        } else if (cdnData && cdnData.url) {
          cdnUrl = cdnData.url;
        } else {
          throw new Error("Resposta do CDN inesperada.");
        }
  
        params.binPublicacao = cdnUrl;
      }

      setLoadingButton(false);
      await api.inserirPublicacao(params);
      Swal.fire({
        icon: 'success',
        title: 'Sucesso!',
        text: 'Notícia inserida com sucesso.',
        confirmButtonColor: '#1789FC',
        confirmButtonText: 'OK',
      }).then(() => {
        navigate('/cms/publicacao/noticia');
      });
    } catch (error) {
      setLoadingButton(false);
      console.error('Erro ao inserir noticia:', error);
      Swal.fire({
        icon: 'error',
        title: 'Ocorreu um erro!',
        text: 'Erro ao inserir notícia. Tente novamente mais tarde.',
        confirmButtonColor: '#1789FC',
        confirmButtonText: 'OK',
      }).then(() => {
        navigate('/cms/publicacao/noticia');
      });
    }
  };

  return (
    <Flex
      direction="column"
      padding='40px'
      background-color='#fafafa'
      width='100%'
      height={formValues.exigeAprovacao.value === 1 ? '100%' : '100%'}
      overflow='hidden'
    >
      <SettingsBreadcrumb />
      <Heading mt="30px" fontWeight="600" fontSize="21px" color="#6F6F6F" w="100%">
        Criar notícia
      </Heading>
      <Box m="40px 0" w="100%">
        <form onSubmit={handleFormSubmit}>
          <div className="row">
            <div className="col-md-6 mb-4">
              <FormControl isRequired isInvalid={formValues.titulo.error}>
                <FormLabel htmlFor="news-category" mb="8px">Categoria da Notícia</FormLabel>
                <Select
                  id="news-category"
                  placeholder='Selecione uma Categoria'
                  borderColor="gray.300"
                  _hover={{ borderColor: 'blue.500' }}
                  value={formValues.categoriaId.value}
                  onChange={(e) => handleFieldChange('categoriaId', e.target.value)}
                >
                  {categorias.length > 0 ? (
                    categorias.map(categoria => (
                      <option key={categoria.seqCategoria} value={categoria.seqCategoria}>
                        {categoria.dscCategoria}
                      </option>
                    ))
                  ) : (
                    ''
                  )}
                </Select>
              </FormControl>
            </div>

            <div className="col-md-6 mb-4">
              <FormControl isRequired isInvalid={formValues.titulo.error}>
                <FormLabel htmlFor="news-title" mb="8px">Título da Notícia</FormLabel>
                <CustomInput
                  id="news-title"
                  value={formValues.titulo.value}
                  onChange={(e: any) => handleFieldChange('titulo', e.target.value)}
                  placeholder="Digite um título"
                />
              </FormControl>
            </div>

            <div className="col-md-6 mb-4">
              <FormControl>
                <FormLabel htmlFor="news-url" mb="8px">Endereço de internet para a notícia</FormLabel>
                <CustomInput
                  id="news-url"
                  value={formValues.endereco.value}
                  onChange={(e) => handleFieldChange('endereco', e.target.value)}
                  placeholder="Digite um endereço de internet"
                />
              </FormControl>
            </div>

            <div className="col-md-3 mb-4">
              <FormControl isRequired>
                <FormLabel mb="8px">Data para Publicação</FormLabel>
                <CustomInput
                  id="news-insert-publication-date"
                  type="date"
                  value={formValues.data.value}
                  onChange={(e) => handleFieldChange('data', e.target.value)}
                  min={today}
                />
              </FormControl>
            </div>
            <div className="col-md-3 mb-4">
              <FormControl>
                <FormLabel mb="8px">Data fim para Publicação</FormLabel>
                <CustomInput
                  id="news-insert-unpublish-date"
                  type="date"
                  value={formValues.dataFim.value}
                  onChange={(e) => handleFieldChange('dataFim', e.target.value)}
                  min={today}
                />
              </FormControl>
            </div>

          </div>
          <div className="row mb-3">
            <div className="col-md-6 mb-4">
              <FormControl>
                <FormLabel mb="8px">Deseja usar modelo na notícia?</FormLabel>
                <RadioGroup
                  mt={3.5}
                  onChange={(value) => {
                    handleInputRadioChange('usarModelo1', Number(value));
                    if (Number(value) === 0) {
                      // Resetar seções ao desselecionar modelo
                      setSelecao([{
                        id: 1,
                        titulo: '',
                        descricao: '',
                        aberto: true,
                        imagem: []
                      }]);
                    }
                  }}
                  value={formValues.usarModelo1.value.toString()}
                >
                  <Radio value="1" mr={5}>Sim</Radio>
                  <Radio value="0">Não</Radio>
                </RadioGroup>
              </FormControl>
            </div>
          </div>

          {formValues.usarModelo1.value === 0 && (
            <div className="row mb-3">
              <div className="col-md-6 mb-4">
                <FormControl className="mb-4">
                  <FormLabel mb="8px">Imagem miniatura</FormLabel>
                  <ImageDropzone
                    onImageSelected={handleImageSelected}
                    base64={imageBase64}
                    height={300}
                    uploadMessage={`Arraste a imagem da notícia aqui ou clique para selecionar.`}
                  />
                  {arquivoSelecionado && (
                    <FormControl isRequired className="mt-3">
                      <FormLabel mb="8px">Crédito/Autor da imagem</FormLabel>
                      <CustomInput
                        placeholder="Digite um crédito ou autor da imagem"
                        value={formValues.creditoAutorImagem.value}
                        onChange={(e) => handleFieldChange('creditoAutorImagem', e.target.value)}
                      />
                    </FormControl>
                  )}
                  {arquivoSelecionado && (
                    <>
                      <FormControl className="mt-3">
                        <FormLabel mb="8px">Descrição de imagem</FormLabel>
                        <CustomInput
                        placeholder="Digite o texto alternativo da imagem"
                        value={formValues.altImagem.value}
                        onChange={(e) => handleFieldChange('altImagem', e.target.value)}
                      />
                    </FormControl>
                  </>
                )}
              </FormControl>
              <FormControl>
                <FormLabel mb="8px">Tags</FormLabel>
                <div style={{ display: 'flex' }}>
                  <CustomInput
                    value={inputValueTagUsuario}
                    onChange={handleInputChangeTagUsuario}
                    placeholder="Digite uma tag"
                    maxLength={100}
                  />
                  <Button onClick={handleAddTagUsuario} ml="2">
                    <FaPlus />
                  </Button>
                </div>
              </FormControl>

              <div className="rolagem-hashtag mb-2">
                <Wrap spacing="2px">
                  {tagUsuario.trim() && tagUsuario.split(' ').map((tag, index) => (
                    <WrapItem key={index}>
                      <Tag variant="solid" colorScheme="blue" maxW="180px" isTruncated>
                        <TagLabel>{tag}</TagLabel>
                        <TagCloseButton onClick={() => handleRemoveTagUsuario(tag)} />
                      </Tag>
                    </WrapItem>
                  ))}
                </Wrap>
              </div>
              </div>
            </div>
          )}

          {formValues.usarModelo1.value === 1 && (
            <div className="row mb-3">
              <div className="col-md-12 mb-4">
                <Box mb="20px">
                  {selecao.map((secao, index) => {
                    return (
                      <Box
                        key={secao.id}
                        borderWidth="1px"
                        borderRadius="md"
                        p="20px"
                        mb="10px"
                        borderColor={'gray.200'}
                      >
                        <Flex justifyContent="space-between" alignItems="center" mb="10px">
                          <Heading as="h5" size="sm">
                            {secao.titulo || `Seção ${index + 1}`}
                          </Heading>
                          <Flex>
                            <Button variant="ghost" size="xs" onClick={() => toggleSelecao(secao.id)} mr="2">
                              {secao.aberto ? <FaMinus /> : <FaPlus />}
                            </Button>
                            <Button variant="ghost" size="xs" colorScheme="red" onClick={() => handleRemoverSelecao(secao.id)}>
                              <FaTimes />
                            </Button>
                          </Flex>
                        </Flex>
                        {secao.aberto && (
                          <Box>
                            <FormControl mb="10px" isRequired>
                              <FormLabel>Título da Seção</FormLabel>
                              <CustomInput
                                value={secao.titulo}
                                onChange={(e) => handleSelecaoChange(secao.id, 'titulo', e.target.value)}
                                placeholder="Digite o título da seção"
                              />
                            </FormControl>

                            <FormControl mb="10px">
                              <FormLabel>Mídia da Seção</FormLabel>
                              <Flex wrap="wrap" gap="20px">
                                {secao.imagem.map(img => {
                                  const isVideo = img.tipo === 'video';

                                  return (
                                    <Box
                                      key={img.id}
                                      borderWidth="1px"
                                      borderRadius="md"
                                      p="10px"
                                      bg="#FFF"
                                      boxShadow="md"
                                      position="relative"
                                    >
                                      <Box
                                        w="150px"
                                        h="100px"
                                        bg="#f0f0f0"
                                        borderRadius="4px"
                                        overflow="hidden"
                                        mx="auto"
                                      >
                                        {isVideo ? (
                                          <video
                                            src={img.imagemPreview}
                                            controls
                                            muted
                                            playsInline
                                            style={{
                                              width: '100%',
                                              height: '100%',
                                              objectFit: 'contain',
                                              display: 'block'
                                            }}
                                            onClick={e => e.stopPropagation()}
                                          />
                                        ) : (
                                          <Image
                                            src={img.imagemPreview}
                                            alt="Preview da mídia"
                                            w="100%"
                                            h="100%"
                                            objectFit="contain"
                                            display="block"
                                            onClick={e => e.stopPropagation()}
                                          />
                                        )}
                                      </Box>

                                      <IconButton
                                        icon={<FaTimes />}
                                        size="xs"
                                        colorScheme="red"
                                        position="absolute"
                                        top="2"
                                        right="2"
                                        borderRadius="full"
                                        aria-label="Remover mídia"
                                        onClick={e => {
                                          e.stopPropagation();
                                          handleRemoveImagem(secao.id, img.id);
                                        }}
                                      />

                                      <Select
                                        mt="10px"
                                        id={`select-posicaoImagem-${secao.id}-${img.id}`}
                                        value={img.posicaoImagem}
                                        onChange={e => handleAtualizarPosicaoImagem(secao.id, img.id, e.target.value)}
                                      >
                                        <option value="" disabled>Posição</option>
                                        {listaPosicaoImagem.map(option => (
                                          <option
                                            key={option.codPropriedade}
                                            value={option.codPropriedade}
                                          >
                                            {option.dscPropriedade}
                                          </option>
                                        ))}
                                      </Select>
                                    </Box>
                                  );
                                })}

                                <Button variant="outline" onClick={() => abrirBibliotecaDeFotos(secao.id)}>
                                  <FaImage color="gray" size="15px" />
                                  <Text pl="6px" mt="4px" fontSize="sm">Adicionar Mídia</Text>
                                </Button>
                              </Flex>
                            </FormControl>

                            <FormControl mb="10px" isRequired>
                              <FormLabel>Descrição da Seção</FormLabel>
                              <QuillEditor
                                value={secao.descricao || ''}
                                placeholder="Digite a descrição da seção"
                                onChange={(content: string) =>
                                  handleSelecaoChange(secao.id, 'descricao', content)
                                }
                              />
                            </FormControl>
                          </Box>
                        )}
                      </Box>
                    );
                  })}
                  <Button onClick={handleAddSelecao} _hover={{ opacity: 0.8 }} leftIcon={<FaPlus />} bgColor="#1665D8" color="#FFF">
                    Adicionar Seção
                  </Button>
                </Box>
              </div>
            </div>
          )}

          <div className="row mb-3">
            <div className="col-md-12 mb-4">
              <FormControl>
                <Flex justify="space-between" align="center" mb="8px">
                  <FormLabel mb="8px">
                    Escolha em quais páginas a notícia deve aparecer <span style={{ color: 'red' }}>*</span>
                  </FormLabel>
                </Flex>
                <CustomInput
                  placeholder="Filtrar páginas por nome"
                  value={filtroNomPagina}
                  onChange={(e) => {
                    const valor = e.target.value;
                    setFiltroNomPagina(valor);
                    if (valor.trim()) {
                      fetchPaginas(valor);
                    } else {
                      fetchPaginas();
                    }
                  }}
                  mb="12px"
                />
                <Box
                  border="1px solid"
                  borderColor="gray.300"
                  borderRadius="md"
                  p={3}
                >
                  <Box overflow="hidden">
                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                      <colgroup>
                        <col style={{ width: '60px' }} />
                        <col />
                      </colgroup>
                      <thead>
                        <tr>
                          <th style={{ textAlign: 'center', padding: '8px', borderBottom: '1px solid #ddd' }}></th>
                          <th style={{ textAlign: 'left', padding: '8px', borderBottom: '1px solid #ddd', color: 'gray' }}>Página</th>
                        </tr>
                      </thead>
                    </table>
                  </Box>

                  <Box
                    className="sidebar-checkbox-pagina"
                    overflowX="auto"
                    overflowY={paginas.length > 5 ? 'auto' : 'visible'}
                    maxH={paginas.length > 5 ? '240px' : 'unset'}
                  >
                    {paginas.length > 0 ? (
                      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                        <tbody>
                          {paginas.map((pagina: any) => (
                            <tr key={pagina.seqPagina} style={{ borderBottom: '1px solid #eee' }}>
                              <td style={{ textAlign: 'center', padding: '12px', width: '60px' }}>
                                <Checkbox
                                  isChecked={selectedPages.includes(pagina.seqPagina)}
                                  onChange={(e) => handleCheckboxChange(pagina.seqPagina, e)}
                                />
                              </td>
                              <td style={{ textAlign: 'left', padding: '12px' }}>
                                {pagina.nomPagina}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    ) : (
                      <Box p={3} textAlign="center" color="gray.500">
                        Não há páginas disponíveis.
                      </Box>
                    )}
                  </Box>
                </Box>
              </FormControl>
            </div>
          </div>

          <div className="row mb-3">
            {formValues.usarModelo1.value === 0 && (
              <div className="col-md-6 mb-4">
                <FormControl>
                  <FormLabel mb="8px">Resumo da Notícia</FormLabel>
                  <CustomTextArea
                    placeholder="Digite um resumo"
                    value={formValues.dscResumo.value}
                    onChange={(e) => handleFieldChange('dscResumo', e.target.value)}
                    height={'90px'}
                  />
                </FormControl>
              </div>
            )}
          </div>

          <div className="row mb-3">
            <div className="col-md-12 mb-4">
              <FormControl className='mb-4'>
                {secretarias.length > 0 && (
                  <>
                    <Flex justify="space-between" align="center">
                      <FormLabel mb="8px">
                        Associe o usuário a uma secretaria (opcional)
                      </FormLabel>
                    </Flex>

                    <CustomInput
                      placeholder="Filtrar secretarias por nome"
                      value={filtroNomSecretaria}
                      onChange={(e) => {
                        const valor = e.target.value;
                        setFiltroNomSecretaria(valor);
                        if (valor.trim()) {
                          fetchSecretarias(valor);
                        } else {
                          fetchSecretarias();
                        }
                      }}
                      mb="12px"
                    />

                    <Box
                      border="1px solid"
                      borderColor="gray.300"
                      borderRadius="md"
                      p={3}
                    >
                      <Box overflow="hidden">
                        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                          <colgroup>
                            <col style={{ width: '60px' }} />
                            <col style={{ width: '120px' }} />
                            <col />
                          </colgroup>
                          <thead>
                            <tr>
                              <th style={{ textAlign:'center', padding:'8px', borderBottom:'1px solid #ddd' }}></th>
                              <th style={{ textAlign:'left',   padding:'8px', borderBottom:'1px solid #ddd', color:'gray' }}>Código</th>
                              <th style={{ textAlign:'left',   padding:'8px', borderBottom:'1px solid #ddd', color:'gray' }}>Secretaria</th>
                            </tr>
                          </thead>
                        </table>
                      </Box>

                      <Box 
                        className="sidebar-checkbox-pagina"
                        overflowX="auto"
                        overflowY={secretarias.length > 5 ? 'auto' : 'visible'}
                        maxH={secretarias.length > 5 ? '240px' : 'unset'}
                      >
                        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                          <colgroup>
                            <col style={{ width: '60px' }} />
                            <col style={{ width: '120px' }} />
                            <col />
                          </colgroup>
                          <tbody>
                          {secretarias.map((secretaria: any) => {
                            const cod = Number(secretaria.codSecretaria);
                            const nome = secretaria.secretariasDTO?.dscSecretaria ?? secretaria.dscSecretaria ?? '—';

                            return (
                              <tr key={cod}>
                                <td style={{ textAlign: "center", padding: "8px", borderBottom: "1px solid #ddd" }}>
                                  <Checkbox
                                    className="checkCategorias"
                                    isChecked={secretariaSelecionada.includes(cod)}
                                    onChange={(e) => handleCheckboxSecretaria(cod, e.target.checked)}
                                  />
                                </td>
                                <td style={{ padding: "8px", borderBottom: "1px solid #ddd" }}>{cod}</td>
                                <td style={{ padding: "8px", borderBottom: "1px solid #ddd" }}>{nome}</td>
                              </tr>
                            );
                          })}
                          </tbody>
                        </table>
                      </Box>
                    </Box>
                  </>
                )}
              </FormControl>
            </div>
          </div>

          <div className="row mb-3">
            {formValues.usarModelo1.value === 0 && (
              <div className="col-md-6 mb-4">
                <Button
                  onClick={handleOpenModal}
                  variant="outline"
                  colorScheme="blue"
                  size="lg"
                  fontSize="md"
                  borderRadius="md"
                  _hover={{ bg: "blue.500", color: "white" }}
                  mt={3}
                >
                  Texto da Notícia
                </Button>
              </div>
            )}
            <div className={formValues.usarModelo1.value === 0 ? "col-md-6 mb-4" : "col-md-12 mb-4"}>
              <FormControl mt={3} isRequired>
                <FormLabel mb="8px">Exige aprovação</FormLabel>
                <RadioGroup
                  mt={3.5}
                  onChange={(value) => handleInputRadioChange('exigeAprovacao', Number(value))}
                  value={formValues.exigeAprovacao.value.toString()}
                >
                  <Radio value="1" mr={5}>Sim</Radio>
                  <Radio value="0">Não</Radio>
                </RadioGroup>
              </FormControl>
            </div>
          </div>

          {formValues.exigeAprovacao.value === 1 && (
            <div className="col-md-12 mb-4">
              <FormControl isRequired={formValues.exigeAprovacao.value === 1}>
                <Flex justify="space-between" align="center" mb="8px">
                  <FormLabel mb="8px">
                    Selecione o aprovador desta publicação
                  </FormLabel>
                </Flex>
                <div className="input-radio-lista">
                  <Stack spacing={5}>
                    {aprovadores.length > 0 ? (
                      aprovadores.map((aprovador: any) => (
                        <Flex key={aprovador.seqUsuario}>
                          <Radio
                            className="radioAprovadoresNoticia"
                            value={aprovador.seqUsuario.toString()}
                            isChecked={selectedUser === aprovador.seqUsuario}
                            onChange={(e) => handleRadioChange(aprovador.seqUsuario, e)}
                          >
                            {aprovador.dscNome}
                          </Radio>
                        </Flex>
                      ))
                    ) : (
                      <p>Não há lista de aprovadores disponíveis.</p>
                    )}
                  </Stack>
                </div>
              </FormControl>
            </div>
          )}

          <Flex mt="35px" justifyContent="end">
            <Button
              m="6px"
              onClick={() => navigate('/cms/publicacao/noticia')}
            >
              Desistir
            </Button>
            <Button
              type="submit"
              m="6px"
              color="#FFF"
              bgColor="#1665D8"
              _hover={{ opacity: 0.8 }}
              isDisabled={!isFormValid()}
              isLoading={isLoadingButton}
              loadingText="Criando Notícia..."
            >
              {formValues.exigeAprovacao.value === 1
                ? 'Enviar para Aprovação'
                : 'Criar Notícia'}
            </Button>
          </Flex>
        </form>
      </Box>

      {formValues.usarModelo1.value === 1 && (
        <BibliotecaModal
          isOpen={bibliotecaOpen}
          onClose={() => setBibliotecaOpen(false)}
          onSelectImage={handleSelectImageFromBiblioteca}
        />
      )}

      <Modal show={isErrorModalOpen} onHide={() => setIsErrorModalOpen(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Atenção!</Modal.Title>
        </Modal.Header>
        <Modal.Body>{errorMessage}</Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={() => setIsErrorModalOpen(false)}>
            Fechar
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={isModalTextOpen} onHide={() => setIsModalTextOpen(false)} size="xl" enforceFocus={false}>
        <Modal.Header closeButton>
          <Modal.Title>Digite o texto da notícia</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <FormControl>
            <CKEditor
              editor={ClassicEditor}
              data={temporaryTexto}
              config={{
                language: 'pt-br',
                toolbar: [
                  'undo', 'redo', '|',
                  'heading', 'bold', 'italic', 'underline', 'strikethrough', '|',
                  'link', '|',
                  'blockQuote', 'insertTable', '|',
                  'horizontalLine',
                ],
                heading: {
                  options: [
                    {
                      model: 'paragraph',
                      title: 'Texto normal',
                      class: 'ck-heading_paragraph'
                    },
                    {
                      model: 'heading1',
                      view: 'h1',
                      title: 'Cabeçalho 1',
                      class: 'ck-heading_heading1'
                    },
                    {
                      model: 'heading2',
                      view: 'h2',
                      title: 'Cabeçalho 2',
                      class: 'ck-heading_heading2'
                    },
                    {
                      model: 'heading3',
                      view: 'h3',
                      title: 'Cabeçalho 3',
                      class: 'ck-heading_heading3'
                    },
                  ]
                },
              }}
              onChange={(event, editor) => {
                const data = editor.getData();
                setTemporaryTexto(data);
              }}
            />
          </FormControl>
          {temporaryTexto && (
            <FormControl isRequired className="mt-3 mb-4">
              <FormLabel>Crédito/Autor da notícia</FormLabel>
              <CustomInput
                placeholder="Digite um crédito ou autor da notícia"
                value={formValues.creditoAutorNoticia.value}
                onChange={(e) => handleFieldChange('creditoAutorNoticia', e.target.value)}
                maxLength={100}
              />
            </FormControl>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => setIsModalTextOpen(false)}>
            Desistir
          </Button>
          <Button
            type="submit"
            m="6px"
            color="#FFF"
            bgColor="#1665D8"
            _hover={{ opacity: 0.8 }}
            onClick={handleSaveText}
            disabled={isSaveButtonDisabled}
            isLoading={isLoadingButton}
            loadingText="Salvando..."
          >
            Salvar
          </Button>
        </Modal.Footer>
      </Modal> 
    </Flex>
  );
};

export default InserirNoticia;
